(function userControllerDefinition() {
    'use strict';

    angular.module('CustomControlUser')
        .controller('UserSearchModalController', [
           '$scope', '$state', '$translate', 'errorsExtend', '$q', '$modalInstance', 'storageService', 'userService', 'authExtend', 'ouId',
            function userController($scope, $state, $translate, errors, $q, $modalInstance, storageService, userService, authExtend, ouId) {
                $scope.ouId = ouId;

                $scope.accordionState = {
                    isOpen: true
                }

                $scope.load = function () {
                    $scope.find =
                    {
                        firstName: '',
                        nickName: '',
                        lastName: '',
                        mail: '',
                        organizationalUnitId: $scope.ouId,
                        organizationalUnitName: '',
                        showNoData: false,
                        organizationalUnitChildestId: $scope.ouId
                    };

                    $scope.items = [];
                    $scope.showResult = false;
                    $scope.selectedOu = {};
                    $scope.emptyOu = false;


                    $translate(['PaginationNext', 'PaginationPrev', 'PaginationLastFem', 'PaginationFirstFem'])
                        .then(function (translated) {
                            $scope.paginatorTranslations = {
                                nextText: translated.PaginationNext,
                                previousText: translated.PaginationPrev,
                                lastText: translated.PaginationLastFem,
                                firstText: translated.PaginationFirstFem
                            };
                        });
                }

                $scope.clean = function () {
                    $scope.find =
                  {
                      firstName: '',
                      nickName: '',
                      lastName: '',
                      mail: '',
                      organizationalUnitId: $scope.ouId,
                      organizationalUnitName: '',
                      showNoData: false,
                      organizationalUnitChildestId: $scope.ouId
                  };

                    $scope.items = [];
                    $scope.accordionState.isOpen = true;
                    $scope.showResult = false;
                }

                $scope.findAction = function () {
                    $scope.items = [];
                    $scope.showResult = true;
                    
                    return userService.get(
                        $scope.find.nickName,
                        $scope.find.firstName,
                        $scope.find.lastName,
                        $scope.find.organizationalUnitId,
                        null,
                        null,
                        $scope.find.mail,
                        $scope.data.currentPage,
                        $scope.data.itemsPerPage
                        ).then(function getOk(result) {
                            $scope.items = result.value;
                            $scope.data.totalItems = result.totalCount;
                            $scope.data.from = result.from;

                            if ($scope.items.length > 0) {
                                $scope.accordionState.isOpen = false;
                            }

                        }, function getError(error) {
                            errors.showError(error);
                        });
                };

                $scope.data = {
                    currentPage: 1,
                    totalItems: 0,
                    itemsPerPage: 15,
                    from: 0
                };


                $scope.cancel = function () {
                    $modalInstance.close(null);
                };

                $scope.select = function () {
                    var selectedUser = {};

                    $scope.items.forEach(function (item) {
                        if (item.check) {
                            selectedUser = item;
                        }
                    });

                    if (selectedUser) {
                        $modalInstance.close(selectedUser);
                    }
                    else {
                        errors.showError('UserAtLeastOneChecked');
                    }
                };

                $scope.updateSelection = function (position, entities) {
                    angular.forEach(entities, function (docu, index) {
                        if (position != index)
                            docu.check = false;
                    });
                }

                $scope.showPanel = function () {
                    $scope.panelOpen = true;
                };

                $scope.hidePanel = function () {
                    $scope.panelOpen = false;
                };

                $scope.load();
            }]);
})();